import { Skeleton } from '@/components/skeleton'

const RecentMarketsSkeleton = () => {
    return (
        <div className="grid grid-cols-4 gap-4">
            <Skeleton className="h-20 rounded-lg" />
            <Skeleton className="h-20 rounded-lg" />
            <Skeleton className="h-20 rounded-lg" />
            <Skeleton className="h-20 rounded-lg" />
        </div>
    )
}

export default RecentMarketsSkeleton
